import React, { useContext } from 'react';
import dayjs from 'dayjs';

import TicketContext from '@totem/components/ticketing/details/ticketContext';
import BulkTimeEntryContext from '@totem/components/ticketing/details/timeEntry/bulkTimeEntry/bulkTimeEntryContext';
import BulkUtilizationScreen from '@totem/components/ticketing/details/timeEntry/bulkTimeEntry/bulkUtilizationScreen';
import EmployeeUtilizationContainer from '@totem/components/ticketing/employeeUtilization/employeeUtilizationContainer';
import { isNotNull } from '@totem/utilities/common';

const BulkUtilizationView = () => {
  const { ticket } = useContext(TicketContext);
  const { timeEntryCommon } = useContext(BulkTimeEntryContext);

  const getResourceById = (resourceId: string) => {
    if (
      isNotNull(ticket) &&
      isNotNull(ticket.ticket) &&
      isNotNull(ticket.ticket.partiesInvolved)
    ) {
      for (const partyInvolved of ticket.ticket.partiesInvolved) {
        if (partyInvolved.id === resourceId) {
          return partyInvolved.email;
        }
      }
    }
    return '';
  };

  const selectedResource = getResourceById(timeEntryCommon.resourceId);
  const selectedDate = dayjs(timeEntryCommon.date);

  return (
    <EmployeeUtilizationContainer
      employees={[selectedResource]}
      startTime={selectedDate.startOf('day').toISOString()}
      endTime={selectedDate.endOf('day').toISOString()}
    >
      <BulkUtilizationScreen />
    </EmployeeUtilizationContainer>
  );
};

export default BulkUtilizationView;
